import IconBase from "react-icon-base";
import React from "react";

export default function Icon(props)  {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<svg id="Layer_1" enable-background="new 0 0 128 128" height="100%" viewBox="0 0 128 128" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="m124 91h-33.7c-1.7 0-3 1.3-3 3s1.3 3 3 3h24.7l-32 24h-54c-12.1 0-22-9.9-22-22s9.9-22 22-22h12c8.8 0 16 7.2 16 16 0 4.9-2.2 9.4-5.8 12.3l-1.1.8c-2.6 1.8-5.7 2.9-9.1 2.9h-12c-5.5 0-10-4.5-10-10s4.5-10 10-10h12.5c1.9 0 3.5 1.6 3.5 3.5s-1.6 3.5-3.5 3.5h-12.6c-1.7 0-3 1.3-3 3s1.3 3 3 3h12.6c5.2 0 9.5-4.3 9.5-9.5s-4.3-9.5-9.5-9.5h-12.5c-8.8 0-16 7.2-16 16s7.2 16 16 16h12c5.3 0 10.1-1.9 13.9-5l39.8-29.8c.1 0 .1-.1.2-.1 5.1-4.2 8.1-10.4 8.1-17 0-12.1-9.9-22-22-22h-12c-6.4 0-12.6 2.2-17.6 6.2 0 0 0 0-.1 0 0 0-38.9 29.2-38.9 29.2-6.9 5.1-11.4 13.3-11.4 22.5 0 15.4 12.6 28 28 28h55c.6 0 1.3-.2 1.8-.6l40-30c1-.8 1.5-2.1 1-3.3s-1.5-2.1-2.8-2.1zm-68.9-39c.1-.1.1-.1.2-.2 3.9-3.1 8.7-4.8 13.7-4.8h12c8.8 0 16 7.2 16 16 0 4.8-2.1 9.3-5.8 12.3l-28.5 21.4c.2-1.2.3-2.4.3-3.7 0-12.1-9.9-22-22-22h-11.3z"/></svg>`,
      }}
    />
  );
};
